import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../../hooks/hooks";
import { selectPlansListItems } from "../../../../../../../redux/plans/selector";
import { selectListItems } from "../../../../../../../redux/library/selector";
import { plans } from "../../../../../../../redux/plans/action";
import PageLoader from "../../../../../../../components/PageLoader";
import Table from "../../../../../../../common/components/table-manager/v1.1/table";


const ListSMSMarketingPlans = ({
  choosenCampaign,
  onSelect,
  onPlanIdChange
}: any) => {
  const dispatch = useAppDispatch();
  const [pageData, setPageData] = useState(1);
  const [pageSize, setPageSize] = useState(10)
  const itemsData = useSelector(selectPlansListItems);
  const libraryData = useSelector(selectListItems);
  const [columnDefs, setColumnDefs] = useState<any>([]);
  const [selectedPlanId, setSelectedPlanId] = useState<number | null>(null);

  // Set initial plan ID based on chosen campaign
  useEffect(() => {
    if (choosenCampaign?.SMSPlanId > 0) {
      setSelectedPlanId(choosenCampaign.SMSPlanId);
    }
  }, [choosenCampaign]);


  useEffect(() => {
    onPlanIdChange(selectedPlanId);
}, [selectedPlanId, onPlanIdChange]); 
  // Update column definitions whenever selectedPlanId changes
  useEffect(() => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer: (params: any) => parseInt(params.node.id, 10) + 1,
      },
      {
        field: 'SelectPlan',
        headerName: 'Select Plan',
        cellRendererFramework: (params: any) => (
          <input
            type="checkbox"
            checked={params.data.Id === selectedPlanId}
            onChange={() => handleCheckboxChange(params.data.Id)}
          />
        ),
      },
      { field: 'Name', headerName: 'Plan' },
   
          { field: 'FrequencyId', headerName: 'Frequency Type', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraryData?.result?.CampaignFrequency} ,sortable: true,filter: false },
      { field: 'StartDate', headerName: 'Start Date', isDateValueFormat: true },
      { field: 'EndDate', headerName: 'End Date', isDateValueFormat: true },
      { field: '', headerName: 'Campaigns', sortable: false, filter: false, cellRenderer: 'customFunctions' },
    ]);
  }, [selectedPlanId, libraryData]);

  // Handle checkbox change event
  const handleCheckboxChange = (planId: number) => {
    console.log(planId,'planId')
    setSelectedPlanId(planId);

  };

  const fetchPlan = () => {
    dispatch(
      plans.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plan/sms-plans/list`,
        entity: 'plans',
        jsonData: {
          
        },
      })
    );
  };

  useEffect(() => {
    fetchPlan();
  }, []);

  return (
    <>
      {itemsData?.isLoading ? (
        <PageLoader />
      ) : (
        <Table
          columnData={columnDefs}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          onSelect={onSelect}
          headingName="Plans"
          checkboxConfig={{
              allowMultiSelect: true,
              defaultSelectedIds: [],
              isDisabled: false,
              keyColumn: 'Id',
            }}
        />
      )}
    </>
  );
};

export default ListSMSMarketingPlans;
